import { render, staticRenderFns } from "./Labs.vue?vue&type=template&id=59dd7cba"
import script from "./Labs.vue?vue&type=script&lang=js"
export * from "./Labs.vue?vue&type=script&lang=js"
import style0 from "./Labs.vue?vue&type=style&index=0&id=59dd7cba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports